/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudIcon20Regular = forwardRef('NetCloudIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.82 7.503A5.376 5.376 0 0 1 13.948 6H14a5.5 5.5 0 1 1 0 11H5.25a4.875 4.875 0 0 1-1.43-9.497ZM9.125 4.5a3.875 3.875 0 0 0-3.868 3.636.75.75 0 0 1-.592.689 3.376 3.376 0 0 0 .638 6.675H14a4 4 0 1 0-.45-7.975.75.75 0 0 1-.787-.487A3.877 3.877 0 0 0 9.126 4.5Z" })));
});
